import { createStore } from "vuex";

export default createStore({
  state: {
    isNewBox: false,
    auth: false,
    isMobile: false,
    isDesctop: false,
    height: 0,
    mailboxSetting: [],
    mailbox: [],
    settings: {
      Gmail: {
        smtp: {
          address: "smtp.gmail.com",
          port: "587",
        },
        imap: {
          address: "imap.gmail.com",
          port: "993",
        },
      },
      Mail: {
        smtp: {
          address: "smtp.mail.ru",
          port: "587",
        },
        imap: {
          address: "imap.mail.ru",
          port: "993",
        },
      },
      Yandex: {
        smtp: {
          address: "smtp.yandex.ru",
          port: "587",
        },
        imap: {
          address: "imap.yandex.ru",
          port: "993",
        },
      },
      Rambler: {
        smtp: {
          address: "smtp.rambler.ru",
          port: "587",
        },
        imap: {
          address: "imap.rambler.ru",
          port: "993",
        },
      },
      Yahoo: {
        smtp: {
          address: "smtp.mail.yahoo.com",
          port: "587",
        },
        imap: {
          address: "imap.mail.yahoo.com",
          port: "993",
        },
      },
    },
  },
  getters: {},
  mutations: {
    deleteBox(state, index) {
      state.mailbox = state.mailbox.filter((_, i) => i !== index);
    },
    deleteMailboxSetting(state, index) {
      state.mailboxSetting = state.mailboxSetting.filter((_, i) => i !== index);
    },
    mailboxSettingAdd(state, res) {
      state.mailboxSetting.push(res);
    },
    mailboxSettingStart(state, res) {
      state.mailboxSetting = res;
    },
    mailboxAdd(state, res) {
      state.mailbox.push(res);
    },
    mailboxAddStart(state, res) {
      state.mailbox = res;
    },
    setAuth(state, res) {
      state.auth = res;
      state.isNewBox = false;
    },
    setNewBox(state, res) {
      state.isNewBox = res;
    },
    setHeight(state, res) {
      state.height = res;
    },
    setMobileStatus(state, res) {
      state.isMobile = res;
    },
    setDesctopStatus(state, res) {
      state.isDesctop = res;
    },
  },
  actions: {},
  modules: {},
});
